// src/components/icons/IconEdit.jsx
import React from 'react';
import { FaEdit } from 'react-icons/fa';

export default function IconEdit({ size = 16, className = '', ...props }) {
  return (
    <FaEdit
      size={size}
      className={`text-gray-500 hover:text-green-600 ${className}`}
      {...props}
    />
  );
}